import { useTypedSelector } from "../../../store/store";
import { ROOT } from "../../../utils/constants/routes";
import { VID_PRIVACY_NOTICE_URL } from "../../../utils/constants/vidPrivacy";
import Logo from "../Logo";

import styles from "./index.module.scss";

function Footer() {
  const { brand } = useTypedSelector((state) => state.environment);

  return (
    <footer className={styles.container}>
      <Logo pathname={ROOT} />

      {brand === "vid" && (
        <a
          href={VID_PRIVACY_NOTICE_URL}
          target="_blank"
          className={styles.link}
          rel="noreferrer">
          Privacy Notice
        </a>
      )}
    </footer>
  );
}

export default Footer;
